import type {
  ClickedElementsQueryResponse,
  ClickedElementsQueryVariables,
} from '~/modules/heatmap/graphql/queries/clickedElements.generated';
import type { BaseHeaderResponse } from '~/api/types/graphqlClient';
import type { IClickedElement } from '~/modules/heatmap/types';
import type { UseQueryOptions } from '@tanstack/react-query';

import { ClickedElementsDocument } from '~/modules/heatmap/graphql/queries/clickedElements.generated';
import { HEATMAP_QUERY_KEYS } from '../../websocket';
import { useQuery } from '@tanstack/react-query';
import { appFetcherCustom } from '~/api/utils';

//TODO: Remove this when the API is ready
export interface CustomClickedElementsResponse extends Omit<
  ClickedElementsQueryResponse,
  'clickedElements'
> {
  clickedElements: IClickedElement[];
  headers: BaseHeaderResponse;
}

export const useCustomClickedElementsQuery = <
  TData = CustomClickedElementsResponse,
  TError = unknown,
>(
  variables: ClickedElementsQueryVariables,
  options?: UseQueryOptions<CustomClickedElementsResponse, TError, TData>,
) => {
  return useQuery<CustomClickedElementsResponse, TError, TData>(
    [HEATMAP_QUERY_KEYS.clickedElements, variables],
    appFetcherCustom<CustomClickedElementsResponse, ClickedElementsQueryVariables>(
      ClickedElementsDocument,
      variables,
    ),
    options,
  );
};

useCustomClickedElementsQuery.getKey = (variables?: ClickedElementsQueryVariables) => [
  HEATMAP_QUERY_KEYS.clickedElements,
  variables,
];
